export const ERROR_CODE_FOR_CUSTOMER: Record<string, string> = {
  9999: 'common.error.code_9999', // 予期せぬエラーが発生しました
  FORBIDDEN: 'error.FORBIDDEN', // 許可されていない操作です。
  CODE_MISMATCH_EXCEPTION: 'error.CODE_MISMATCH_EXCEPTION', // コードは正しくありません。
  EXPIRED_CODE_EXCEPTION: 'error.EXPIRED_CODE_EXCEPTION', // コードは正しくありません。
  ANSWER_LOCK_CONFLICT_EXCEPTION: 'error.ANSWER_LOCK_CONFLICT_EXCEPTION',
  ESG_DATA_ANSWER_GROUP_VERSIONS_NOT_FOUND: 'error.ESG_DATA_ANSWER_GROUP_VERSIONS_NOT_FOUND',
  ESG_DATA_NAME_DUPLICATE_EXCEPTION: 'error.ESG_DATA_NAME_DUPLICATE_EXCEPTION',
  ESG_DATA_ANSWER_GROUP_VERSIONS_ALREADY_SHARED_EXCEPTION: 'error.ESG_DATA_ANSWER_GROUP_VERSIONS_ALREADY_SHARED_EXCEPTION',
  ESG_DATA_ALREADY_SHARED_EXCEPTION: 'error.ESG_DATA_ALREADY_SHARED_EXCEPTION',
  ESG_DATA_UNANSWERED_SHARE_EXCEPTION: 'error.ESG_DATA_UNANSWERED_SHARE_EXCEPTION',
  ESG_DATA_MAX_SHARE_LIMIT_EXCEPTION: 'error.ESG_DATA_MAX_SHARE_LIMIT_EXCEPTION',
  ESG_DATA_INVITATION_EXPIRED_EXCEPTION: 'error.ESG_DATA_INVITATION_EXPIRED_EXCEPTION',
  ESG_DATA_USER_ALREADY_REGISTERED_EXCEPTION: 'error.USER_ALREADY_REGISTERED_EXCEPTION',
  ESG_DATA_OWN_COMPANY_SHARE_EXCEPTION: 'error.ESG_DATA_OWN_COMPANY_SHARE_EXCEPTION',
  ANSWER_GROUP_INVITATION_IS_NOT_EXIST_EXCEPTION: 'error.ANSWER_GROUP_INVITATION_IS_NOT_EXIST_EXCEPTION',
  ANSWER_GROUP_INVITATION_IS_INVALID_EXCEPTION: 'error.ANSWER_GROUP_INVITATION_IS_INVALID_EXCEPTION',
  ANSWER_GROUP_INVITATION_WRONG_PASSWORD_EXCEPTION: 'error.ANSWER_GROUP_INVITATION_WRONG_PASSWORD_EXCEPTION',
  ANSWER_GROUP_INVITATION_TOKEN_EXPIRED_EXCEPTION: 'error.ANSWER_GROUP_INVITATION_TOKEN_EXPIRED_EXCEPTION',
  ANSWER_GROUP_INVITATION_UNAUTHORIZED_EXCEPTION: 'error.ANSWER_GROUP_INVITATION_UNAUTHORIZED_EXCEPTION',
  ANSWER_GROUP_INVITATION_ALREADY_EXIT: 'error.ANSWER_GROUP_INVITATION_ALREADY_EXIT',
  ANSWER_GROUP_INVITATION_OWN_COMPANY_SHARE_EXCEPTION: 'error.ANSWER_GROUP_INVITATION_OWN_COMPANY_SHARE_EXCEPTION',
  BUYER_CREATE_QUESTION_GROUP_LIMIT_EXCEEDED_EXCEPTION: 'error.BUYER_CREATE_QUESTION_GROUP_LIMIT_EXCEEDED_EXCEPTION',
  BUYER_CREATE_QUESTION_GROUP_LOCALE_NAMES_NOT_FOUND_EXCEPTION: 'error.BUYER_CREATE_QUESTION_GROUP_LOCALE_NAMES_NOT_FOUND_EXCEPTION',
  CAN_NOT_EDIT_BUYER_CREATED_QUESTION_GROUP_EXCEPTION: 'error.CAN_NOT_EDIT_BUYER_CREATED_QUESTION_GROUP_EXCEPTION',
  EXPIRED_DATE_IS_NOT_FUTURE_DATE_EXCEPTION: 'error.EXPIRED_DATE_IS_NOT_FUTURE_DATE_EXCEPTION',
} as const satisfies Record<string, string>

export const hasErrorMessageForCustomer = (code: string) => {
  return code in ERROR_CODE_FOR_CUSTOMER
}

export const getErrorMessageForCustomer = (code: string, message: string, t: (key: string) => string) => {
  if (!hasErrorMessageForCustomer(code)) {
    return message || t(ERROR_CODE_FOR_CUSTOMER[9999])
  }
  switch (code) {
    // カスタマイズする場合のサンプル例
    case 'sample':
      return `${t(ERROR_CODE_FOR_CUSTOMER[code])}\n\n${t(message)}` // messageをlocalesファイルへのアクセスキーとして変換する処理などを入れる
    default:
      return t(ERROR_CODE_FOR_CUSTOMER[code])
  }
}
